import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styles: [
  ]
})
export class NotfoundComponent implements OnInit {

  constructor(private router: Router) {
    // This is intentional
  }

  ngOnInit(): void {
    // This is intentional
  }

  volver() {
    this.router.navigateByUrl('/');
  }

}
